// Mirror of server/src/utils/permissions.ts — keep these in sync.
export const PERMISSIONS = {
  DASHBOARD_VIEW: 'dashboard:view',
  DASHBOARD_VIEW_LIMITED: 'dashboard:view_limited',

  CATEGORIES_MANAGE: 'categories:manage',
  PRODUCTS_MANAGE: 'products:manage',
  PRODUCTS_PRICE_CHANGE: 'products:price_change',

  ORDERS_CREATE: 'orders:create',
  ORDERS_VIEW: 'orders:view',
  ORDERS_UPDATE_STATUS: 'orders:update_status',
  ORDERS_EDIT: 'orders:edit',
  ORDERS_CANCEL: 'orders:cancel',

  PAYMENTS_COLLECT: 'payments:collect',
  PAYMENTS_REFUND: 'payments:refund',
  BILLS_PRINT: 'bills:print',

  KITCHEN_VIEW: 'kitchen:view',
  KITCHEN_UPDATE: 'kitchen:update',

  CUSTOMERS_MANAGE: 'customers:manage',
  EXPENSES_MANAGE: 'expenses:manage',

  REPORTS_VIEW: 'reports:view',
  REPORTS_EXPORT: 'reports:export',

  SETTINGS_MANAGE: 'settings:manage',
  USERS_MANAGE: 'users:manage',
  AUDIT_VIEW: 'audit:view',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
